import { ChatComponent } from "@/components/pieces/chat/ChatComponent";

import { ModalContainer } from "./ModalContainer";

interface ServiceMessagesProps {
  object: {
    chatChannelId: string;
    customerId: string;
  };
}

export function ServiceMessages({ object }: ServiceMessagesProps) {
  return (
    <ModalContainer>
      <ChatComponent
        channelId={object.chatChannelId}
        customerId={object.customerId}
        frozenMessage="Messaging no longer available"
      />
    </ModalContainer>
  );
}
